export default "__VITE_ASSET___DkTxv35__"